export default __webpack_public_path__ + "static/media/4.fbc2fc9c.gif";